interface IPrice {
  unit_amount: number;
  price_id: string;
}

export interface IPlan {
  plan_id: string;
  encapsulated_plans: string[];
  childPlans?: IPlan[];
  plan_tier: number;
  current?: ISubscriptionPlan;
  additional?: IPlan;
  display: {
    border_color: string;
    accent_color: string;
    name: string;
    sport_category: string;
    default_upgrade_plan_id: string;
  }
  prices: {
    yearly: IPrice,
    monthly: IPrice
  }
  features: string[]
}

export interface IPlanSubscribed extends IPlan, Omit<ISubscription, 'plans'> {
  'interval': 'year' | 'month',
  'price_id': string,
  'price': string,
}

export interface ISubscriptionPlan {
  'plan_id': string,
  'display_name': string,
  'price_id': string,
  'price': string,
  'interval': 'year' | 'month';
  'subscription'?: ISubscription;
}

export interface ISubscription {
  'subscription_id': string,
  'status': 'active' | string,
  'billing_cycle_anchor': number,
  'cancel_at_period_end': boolean,
  'canceled_at': number | null,
  'cancel_at': number | null,
  'created_at': number,
  'current_period_end': number,
  'current_period_start': number,
  'trial_start': number | null,
  'trial_end': number | null,
  'discount': {},
  'plans': ISubscriptionPlan[]
}

export interface IOnePaymentItemDiscount {
  'plan_id': string,
  'amount_off': number,
  'pct_off': number,
  'period_restriction': string
}

export interface IOnePaymentItem {
  'id': number,
  'string_id': string,
  'name': string,
  'description': string,
  'available': boolean,
  'base_price': number,
  'subscriber_price': number,
  'subscriber_period_restriction': string,
  'subscriber_sports_restriction': string[],
  'discounts': IOnePaymentItemDiscount[]
}

export interface IBoughtOnePaymentItem {
  active: boolean
  id: number,
  purchase_date: string,
  item: {
    'available': boolean,
    'base_price': number,
    description: string,
    id: number,
    name: string,
    string_id: string,
    subscriber_period_restriction: "yearly" | "monthly",
    subscriber_price: number
    subscriber_sports_restriction: string[],
  }
}

export enum ModeEnum {
  full = "full",
  widget = "widget"
}
